<dashboardnav>
    <cradua-seismic-crew
    [seismiccrews]="seismiccrews$ | async"
    (seismiccrew)="onSubmitSeismicCrew($event)"
    (deleteSeismicCrewEvent)="onDeleteSeismicCrew($event)"
    *ngIf="(isLoadingSeismicCrew$ | async ) === false"
    >
  </cradua-seismic-crew>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingSeismicCrew$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
